import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import logo2 from '../../logo.png';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () =>
        setScrolled(window.pageYOffset > 1)
      );
    }
  }, []);
  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.container}>
            <img className={styles.logo} src={logo2} />
            <ul className={styles.menu}>
                <li>
                  <a className={styles.menuItem} href="#rarity">Rarity</a>
                </li>
                <li>
                  <a className={styles.menuItem} href="#faq">FAQ</a>
                </li>
            </ul>
        </div>
    </header>
  );
}

export default Header;
